import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

export type TLeagueRegistrationInputTypes = "input" | "select" | "checkbox" | "text";

export interface ILeagueRegistrationInput {
  id: number;
  label: string;
  required: boolean;
  type: TLeagueRegistrationInputTypes;
  help_text: string;
  row: number;
  column: number;
  values: string[] | null;
}

type TGetLeagueRegistrationInput = {
  league_id?: number;
};

export type TPostLeagueRegistrationInput = {
  league_id: number;
  label: string;
  help_text: string;
  type: TLeagueRegistrationInputTypes;
  required?: boolean; // backend defaults to true if not given
};

export type TPutLeagueRegistrationInput = {
  id: number;
  label?: string;
  help_text?: string;
  type?: TLeagueRegistrationInputTypes;
  values?: string[];
  required?: boolean;
};

export type TPutLeagueRegistrationInputPosition = {
  id: number;
  row: number;
  column: number;
};

type TGetLeagueRegistrationInputResponse = {
  participant_id?: number;
};

export type TLeagueRegistrationInputResponse = {
  id: number;
  participant_id: number;
  label: string;
  type: TLeagueRegistrationInputTypes;
  value: string | boolean;
};

type TGetLeagueRegistrationInputResponseExport = {
  league_id: number;
};

export async function GetLeagueRegistrationInput(
  params: TGetLeagueRegistrationInput,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ILeagueRegistrationInput[]>(
    APIUrl(AdminType.FacilityAdmin, "/league/registration-input"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostLeagueRegistrationInput(params: TPostLeagueRegistrationInput, useGlobalLoader: boolean) {
  return await APIPost<ILeagueRegistrationInput>(
    APIUrl(AdminType.FacilityAdmin, "/league/registration-input"),
    params,
    useGlobalLoader,
  );
}

export async function PutLeagueRegistrationInput(params: TPutLeagueRegistrationInput, useGlobalLoader = true) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league/registration-input"), params, useGlobalLoader);
}

export async function DeleteLeagueRegistrationInput(params: { id: number }, useGlobalLoader = true) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/league/registration-input"), params, useGlobalLoader);
}

export async function PutLeagueRegistrationInputPositions(
  params: { inputs: TPutLeagueRegistrationInputPosition[] },
  useGlobalLoader = true,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/league/registration-input/position"), params, useGlobalLoader);
}

export async function GetLeagueRegistrationInputResponse(
  params: TGetLeagueRegistrationInputResponse,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TLeagueRegistrationInputResponse[]>(
    APIUrl(AdminType.FacilityAdmin, "/league/registration-input/response"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetLeagueRegistrationInputResponseExport(
  params: TGetLeagueRegistrationInputResponseExport,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<string>(
    APIUrl(AdminType.FacilityAdmin, "/league/registration-input/response/export"),
    params,
    useGlobalLoader,
    token,
  );
}
